import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48e0ec4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-code-display" }
const _hoisted_2 = { class: "symbol" }
const _hoisted_3 = {
  key: 1,
  class: "delay-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.symbol), 1),
    (_ctx.showMarket && _ctx.marketLabel)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "market-label",
          style: _normalizeStyle({ color: _ctx.marketColor })
        }, _toDisplayString(_ctx.marketLabel), 5))
      : _createCommentVNode("", true),
    (_ctx.isDelayed)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "延"))
      : _createCommentVNode("", true)
  ]))
}